<div class="nav-header-small-gray">
  <div style="display: flex; justify-content: space-around">
    <!-- LANGUAGE SELECTION -->
    <div class="flex-1 show-desktop"></div>
    <!-- APPLICATION TITLE -->
    <div style="padding-top: 3px; flex: 1">
      <span class="title-hidden-xs" style="display: flex; justify-content: space-around">
        DIS
        @if (!environment.production) {
          {{ environment.environmentName }}
        }
      </span>
    </div>

    <!-- LOGGED IN USER -->
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        padding-top: 2px;
        font-size: 13px;
        flex: 1;
      "
    >
      <div style="display: flex; justify-content: end">
        <span>
          {{ user?.fullName }}
        </span>
      </div>
      <div>
        <button
          [matTooltip]="'Logout'"
          (click)="logout()"
          mat-button
          style="display: flex; justify-content: center; align-items: center; height: 22px"
        >
          <mat-icon style="font-size: 18px"> logout</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 2nd row - LOGO -->
<div class="nav-header-large">
  <div style="display: flex; justify-content: space between">
    <!-- POSSIBLE SIDE NAVIGATION -->
    <div style="margin-left: -3px; flex: 1"></div>

    <!-- LOGO -->
    <div style="flex: 1">
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <button mat-button class="no-hover" [routerLink]="'/'">
          <img
            style="width: 146px; margin-top: 14px"
            alt="Montblanc"
            src="../../../assets/Logo_MTB.png"
          />
        </button>
      </div>
    </div>

    <!-- SEARCH -->
    <div style="flex: 1"></div>
  </div>
</div>
<!-- 3rd row - NAVIGATION -->
<div class="nav-header-small-black">
  <div style="display: flex; justify-content: center">
    <div></div>
    <!-- NAVIGATION -->
    <div style="margin-top: -1px">
      <!-- CATALOGS -->

      <a routerLink="/dashboard" class="link" routerLinkActive="link-active">
        <button mat-button class="link" style="height: auto">
          <span>Dashboard</span>
        </button>
      </a>

      @if (showDeliveryNotificationButton()) {
        <a routerLink="/deliveryNotifications" class="link" routerLinkActive="link-active">
          <button mat-button class="link" style="height: auto">
            <span>Delivery Notifications</span>
          </button>
        </a>
      }
      @if (showReturnProcessButton()) {
        <a routerLink="/ReturnProcess" class="link" routerLinkActive="link-active">
          <button mat-button style="height: auto" class="link">
            <span>Return Process</span>
          </button>
        </a>
      }

      @if (showCompaniesButton() || showUsersButton() || showNewsButton()) {
        <button
          mat-button
          class="link"
          style="height: auto"
          routerLinkActive="link-active"
          [matMenuTriggerFor]="contentMenu"
        >
          <span>Admin</span>
        </button>
      }

      <mat-menu #contentMenu="matMenu" routerLinkActive="link-active">
        <!-- Users -->
        @if (showUsersButton()) {
          <button mat-menu-item routerLink="/users" routerLinkActive="link-active">Users</button>
        }
        @if (showCompaniesButton()) {
          <button mat-menu-item routerLink="/companies" routerLinkActive="link-active">
            Companies
          </button>
        }
        @if (showNewsButton()) {
          <button mat-menu-item routerLink="/news" routerLinkActive="link-active">News</button>
        }
      </mat-menu>
    </div>
    <div></div>
  </div>
</div>
